import React from 'react';
import { Tag, Wrapper } from 'components';
import { Appearance } from 'design';
import { formatTime, formatTimezone } from 'utils/date';

interface IBusinessDayStartItemProps {
  businessDayStart?: string;
  timezone?: string;
}

const getLabel = (businessDayStart: string, timezone?: string) => `${formatTime(businessDayStart, true)} ${formatTimezone(timezone)}`.trim();

export const BusinessDayStartItem: React.FC<IBusinessDayStartItemProps> = ({ businessDayStart, timezone }) => {
  if (!businessDayStart) return null;
  return (
    <Wrapper direction="row" alignItems="center">
      <Tag dataCy="business-day-start-tag" label={getLabel(businessDayStart, timezone)} appearance={Appearance.SECONDARY} capitalize={false} />
    </Wrapper>
  );
};
